<template>
  <nav>
    <div class="inner">
      <ul class="sf-menu">
        <li :key="page.ItemID" v-for="page in pages">
          <router-link :to="page.url == 'default' ? '/' : '/' + page.url">
            {{page.name}}
            <i
              class="fa fa-caret-down"
              v-if="(page.subs && page.subs.length) || page.ItemID == 'ZW4N72VDd'"
            />
          </router-link>
          <ul v-if="(page.subs && page.subs.length) || page.ItemID == 'ZW4N72VDd'">
            <li>
              <router-link :to="page.url == 'default' ? '/' : '/' + page.url">{{page.name}}</router-link>
            </li>
            <li v-if="page.ItemID == 'ZW4N72VDd'">
              <a
                href="https://configurator.ctbutterfield.com/"
                target="_blank"
                rel="noreferrer"
              >Design a Memorial</a>
            </li>
            <li :key="sub.ItemID" v-for="sub in page.subs">
              <router-link :to="'/' + sub.url">{{sub.name}}</router-link>
            </li>
          </ul>
        </li>
        <li><a :href="settings.price_list" target="_blank" rel="noreferrer">Standardised Price List</a></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "PageNavigation",
  props: ["pages", "settings"],
  created: function() {}
}
</script>

<style scoped>
.inner {
  text-align: center;
}

nav {
  background: #b1ba22;
  color: white;
  position: relative;
  z-index: 2;
  text-transform: uppercase;
}

nav i {
  margin-left: 0.5rem !important;
  opacity: 0.5;
}

/*** SF MENU ***/
.sf-menu,
.sf-menu * {
  margin: 0;
  padding: 0;
  list-style: none;
}
.sf-menu li {
  position: relative;
}
.sf-menu ul {
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  z-index: 99;
  text-align: left;
}
.sf-menu > li {
  float: left;
}
.sf-menu li:hover > ul,
.sf-menu li.sfHover > ul {
  display: block;
}

.sf-menu a {
  display: block;
  position: relative;
}
.sf-menu ul ul {
  top: 0;
  left: 100%;
}

/*** DEMO SKIN ***/
.sf-menu {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  display: inline-block;
  margin-bottom: -0.25rem;
}
.sf-menu ul {
  min-width: 12em; /* allow long menu items to determine submenu width */
  *width: 12em; /* no auto sub width for IE7, see white-space comment below */
}
.sf-menu a {
  padding: 2rem 2.5rem;
  text-decoration: none;
  zoom: 1; /* IE7 */
}

.sf-menu li {
  white-space: nowrap; /* no need for Supersubs plugin */
  *white-space: normal; /* ...unless you support IE7 (let it wrap) */
  -webkit-transition: background 0.2s;
  transition: background 0.2s;
}

.sf-menu li ul li {
  width: 100%;
}
.sf-menu li ul li a {
  padding: 1.5rem 1em;
}

.sf-menu > li > a {
  display: block;
}

.sf-menu ul li {
  background: #b9c139;
}
.sf-menu ul ul li {
  background: rgba(255, 255, 255, 0.1);
}
.sf-menu li:hover,
.sf-menu li.sfHover {
  background: #b9c139;
  /* only transition out, not in */
  -webkit-transition: none;
  transition: none;
}
.sf-menu li ul li:hover {
  background: rgb(192, 201, 73);
}

/*** arrows (for all except IE7) **/
.sf-arrows .sf-with-ul {
  padding-right: 2.5em;
  *padding-right: 1em; /* no CSS arrows for IE7 (lack pseudo-elements) */
}
/* styling for both css and generated arrows */
.sf-arrows .sf-with-ul:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 1em;
  margin-top: -3px;
  height: 0;
  width: 0;
  /* order of following 3 rules important for fallbacks to work */
  border: 5px solid transparent;
  border-top-color: #dfeeff; /* edit this to suit design (no rgba in IE8) */
  border-top-color: rgba(255, 255, 255, 0.5);
}
.sf-arrows > li > .sf-with-ul:focus:after,
.sf-arrows > li:hover > .sf-with-ul:after,
.sf-arrows > .sfHover > .sf-with-ul:after {
  border-top-color: white; /* IE8 fallback colour */
}
/* styling for right-facing arrows */
.sf-arrows ul .sf-with-ul:after {
  margin-top: -5px;
  margin-right: -3px;
  border-color: transparent;
  border-left-color: #dfeeff; /* edit this to suit design (no rgba in IE8) */
  border-left-color: rgba(255, 255, 255, 0.5);
}
.sf-arrows ul li > .sf-with-ul:focus:after,
.sf-arrows ul li:hover > .sf-with-ul:after,
.sf-arrows ul .sfHover > .sf-with-ul:after {
  border-left-color: white;
}

@media screen and (max-width: 1500px) {
  .sf-menu a {
    padding: 2rem 2rem;
  }
}
@media screen and (max-width: 1400px) {
  .sf-menu a {
    padding: 2rem 1.5rem;
    font-size: 1.3rem;
  }
}
@media screen and (max-width: 1200px) {
  .sf-menu a {
    font-size: 1.4rem;
  }
}
@media screen and (max-width: 990px) {
  nav {
    display: none;
  }
}
</style>
